import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ContentSection } from '../components/ContentSection';
import { VideoSection } from '../components/VideoSection';
import { BonusSection } from '../components/BonusSection';
import { CertificateSection } from '../components/CertificateSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { PricingSection } from '../components/PricingSection';
import { ColorimetriaInfoSection } from '../components/ColorimetriaInfoSection';
import { ClosingSection } from '../components/ClosingSection';
import { FAQSection } from '../components/FAQSection';
import { SocialProofPopup } from '../components/SocialProofPopup';
import { WhatsAppButton } from '../components/WhatsAppButton';
export function LandingPage() {
  return <main className="w-full min-h-screen" data-id="element-347">
      <HeroSection data-id="element-348" />
      <ProblemSection data-id="element-349" />
      <SolutionSection data-id="element-350" />
      <ContentSection data-id="element-351" />
      <VideoSection data-id="element-352" />
      <BonusSection data-id="element-353" />
      <CertificateSection data-id="element-354" />
      <PricingSection data-id="element-355" />
      <ColorimetriaInfoSection data-id="element-356" />
      <TestimonialsSection data-id="element-357" />
      <ClosingSection data-id="element-358" />
      <FAQSection data-id="element-359" />
      <SocialProofPopup data-id="element-360" />
      <WhatsAppButton data-id="element-361" />
    </main>;
}